module.exports = __webpack_public_path__ + "img/icon54.0456ebf2.png";